import { ROOT_ID } from '@constants/common';
import React from 'react';
import { createPortal } from 'react-dom';
import Toast from '@components/common/Toast/Toast';
import { useToast } from '@hooks/useToast';
import styles from './Toasts.module.scss';

// The SPA root / the funnel island mount element. A template page without one
// (e.g. the profile, where only the overlay host island is mounted) falls back
// to <body>.
const getPortalTarget = (): HTMLElement =>
  document.getElementById(ROOT_ID) ?? document.body;

/** Mount once per page: renders whatever `useToast().open` added. */
const Toasts: React.FC = () => {
  const { toasts, close } = useToast();

  return createPortal(
    <div className={styles.wrapper}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          close={() => close(toast.id)}
          type={toast.type}
          duration={toast.duration}>
          {toast.content}
        </Toast>
      ))}
    </div>,
    getPortalTarget()
  );
};

export default Toasts;
